var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "bg-control",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 3.5,
    style: {
      fill: "#FFF"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,18H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H14a4,4,0,0,1,4,4V14A4,4,0,0,1,14,18ZM4,1A3,3,0,0,0,1,4V14a3,3,0,0,0,3,3H14a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckbox);
export default __webpack_public_path__ + "static/media/icon-checkbox.b067b7e0f50ae513d4f1a505957b6d52.svg";
export { ForwardRef as ReactComponent };